// extracted by mini-css-extract-plugin
module.exports = {"project":"Project_project__2Ep7r","picture":"Project_picture__1ST0f"};